import React, { lazy, Suspense, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";
import { useQuery } from "@apollo/client";
import { GET_SAVED_NOTIFICATION } from "../../graphql/queries";
//import MyNotificationDetail from "./MyNotificationDetail";

import SimpleModalCompact from "../common/ModalCompact/SimpleModalCompact";

const MyNotificationDetail = lazy(() => import("./MyNotificationDetail"));

const MyNotificationModal = ({
  open,
  handleClose,
  savedNotificationId,
  notificationName,
  onRequestWorkspace,
}) => {

  const intl = useIntl();

  const [notificationData, setNotificationData] = useState();
  const [modalTitle, setModalTitle] = useState(notificationName);
  const [statusMessage, setStatusMessage] = useState();

  const { data, loading, error } = useQuery(GET_SAVED_NOTIFICATION, {
    variables: {
      savedNotificationId,
    },
    skip: !savedNotificationId,
  });

  const requestWorkspace = siteId => {
    if (typeof onRequestWorkspace === "function") {
      onRequestWorkspace(siteId);
    }
  };

  useEffect(() => {
    if (!error && data) {
      var notificationData =
        data?.myNotificationContext?.getSavedEventsByNotification;
      if (notificationData) {
        requestWorkspace(notificationData.siteId);
        setModalTitle(notificationData.name ?? notificationName);
        setNotificationData(notificationData);
        setStatusMessage();
      }
    } else if (error) {
      var errorMessage = intl.formatMessage({
        id: "common.genericErrorMessage",
      });
      setModalTitle(errorMessage);
      setStatusMessage(errorMessage);
    } else if (loading) {
      var loadingMessage = intl.formatMessage({ id: "common.genericLoading" });
      setModalTitle(loadingMessage);
      setStatusMessage(loadingMessage);
    }
  }, [data, loading, error]);

  return (
       
    <SimpleModalCompact open={open} title={modalTitle} onClose={handleClose} fullScreen >
        {(loading || error) && statusMessage}
        {!loading && !error && (
          <Suspense fallback={<div>Loading notification details...</div>}>
            <MyNotificationDetail notificationData={notificationData} />
          </Suspense>
        )}
    </SimpleModalCompact >
  );
};

MyNotificationModal.defaultProps = {
  onRequestWorkspace: () => {},
};

MyNotificationModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  notificationName: PropTypes.string.isRequired,
  onRequestWorkspace: PropTypes.func,
  open: PropTypes.bool.isRequired,
  savedNotificationId: PropTypes.number.isRequired,
};

export default MyNotificationModal;
